<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .header {
    @include mixins.body1-bold();
  }

  .body {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(20px);
    align-items: center;

    .currency-section {
      width: 100%;
      display: flex;

      .input {
        width: utils.in_rem(200px);
      }
    }

    .salary-section {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(15px);

      .section-title {
        @include mixins.body2-bold();
      }

      .section-inputs {
        display: flex;
        flex-direction: column;
        gap: utils.in_rem(10px);

        .row {
          display: flex;
          width: 100%;
          justify-content: space-between;

          .row-item {
            flex: 1 1 calc(50% - utils.in_rem(13px));
            max-width: calc(50% - utils.in_rem(13px));
          }
        }

        .input {
          width: utils.in_rem(200px);
        }
      }
    }
  }
</style>

<script>
  import { derived } from "svelte/store";
  import { editContactStore } from "../../stores";
  import { currenciesStore } from "../../../../../api-stores/currencies-store";
  import SingleSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/SingleSelectDropdown/SingleSelectDropdown.svelte";
  import TextInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/TextInput.svelte";
  import RangeInput from "./components/RangeInput.svelte";

  const currencyItems = derived(currenciesStore, ($currenciesStore) => {
    const currencies = $currenciesStore?.currencies || [];
    return [
      { id: "", label: "None", description: "No currency selected" },
      ...currencies.map((currency) => ({
        id: currency.code,
        label: currency.code,
        description: currency.name,
      })),
    ];
  });

  currenciesStore.once();

  let { children } = $props();
</script>

<div class="header">
  {#if children}
    {@render children()}
  {/if}
</div>

<div class="body">
  <div class="currency-section">
    <div class="input">
      <SingleSelectDropdown
        label="Currency"
        items={$currencyItems}
        bind:selected={$editContactStore["salaryCurrency"]}
        showDescription
        showFilter
      />
    </div>
  </div>

  <div class="salary-section">
    <div class="section-title">Current Salary</div>
    <div class="section-inputs">
      <div class="row">
        <div class="row-item">
          <div class="input">
            <TextInput
              label="Salary"
              bind:value={$editContactStore["salary"]}
            />
          </div>
        </div>
        <div class="row-item">
          <div class="input">
            <TextInput
              label="Bonus"
              bind:value={$editContactStore["currentBonus"]}
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="salary-section">
    <div class="section-title">Expected Salary</div>
    <div class="section-inputs">
      <div class="row">
        <div class="row-item">
          <RangeInput label="Salary" id="expectedSalary" />
        </div>
        <div class="row-item">
          <RangeInput label="Bonus" id="expectedBonus" />
        </div>
      </div>
    </div>
  </div>
</div>
